import { gql } from "@apollo/client";

export const GET_SAVED_COLUMNS = gql`
  query GetSavedColumns($employeeId: String, $tableId: String) {
    getSavedColumns(employeeId: $employeeId, tableId: $tableId) {
      employeeId
      tableId
      visibleColumns
    }
  }
`;

export const SAVE_COLUMNS = gql`
  mutation SaveColumns(
    $employeeId: String
    $tableId: String
    $visibleColumns: [String]
  ) {
    saveColumns(
      employeeId: $employeeId
      tableId: $tableId
      visibleColumns: $visibleColumns
    ) {
      employeeId
      tableId
      visibleColumns
    }
  }
`;
